import { render, staticRenderFns } from "./MultiInputField.vue?vue&type=template&id=656a9ef1&scoped=true"
import script from "./MultiInputField.vue?vue&type=script&lang=js"
export * from "./MultiInputField.vue?vue&type=script&lang=js"
import style0 from "./MultiInputField.vue?vue&type=style&index=0&id=656a9ef1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656a9ef1",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {InputField: require('/home/runner/work/WordFinder-V3/WordFinder-V3/components/common/InputField.vue').default})
